import {Component} from "react"
import {Nav, NavItem, NavLink} from "reactstrap"
import PropTypes from "prop-types"

import './NavTabs.scss'

export class NavTabs extends Component {

  static propTypes = {
    navItems: PropTypes.array,
  }

  mappedLinks = () => {

    if (!this.props.navItems) {
      return null
    }
    return this.props.navItems.map((navItem, index) => {
      return (
        <NavItem key={`tab-${index}`} active={navItem.isActive}>
          <NavLink
            onClick={navItem.onClick}
            active={navItem.isActive}>
              {navItem.icon || ''}
              {navItem.text}
              {navItem.number ? <span>{ navItem.number }</span> : ''}
          </NavLink>
        </NavItem>
      )
    })
  }

  render() {
    return <Nav tabs>
      {this.mappedLinks()}
    </Nav>
  }
}
